import { PropsWithChildren } from 'react';
import { Stack } from './Stack';
import { twMerge } from 'tailwind-merge';

type Props = PropsWithChildren<{
  className?: string;
  width?: number;
}>;

export function ActionButtons({ children, width, className }: Props) {
  const classNames = twMerge('justify-end items-center flex flex-grow', className);

  return (
    <Stack className={classNames}>
      <Stack gap={2} className={twMerge('w-72', `w-${width}`)}>
        {children}
      </Stack>
    </Stack>
  );
}
